import { Icon, IconProps } from './Icon';

export const SmartToolsPlacesNearbyIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M5.99734 13.1533C4.15958 13.9777 2.99609 15.1702 2.99609 16.5017C2.99609 18.9877 7.02677 21.0036 11.9998 21.0036C16.9729 21.0036 21.0036 18.9877 21.0036 16.5017C21.0036 15.1702 19.8401 13.9777 18.0023 13.1533"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15.6537 17.002C14.5696 17.7074 13.2925 18.0571 12.0002 18.0024C10.7079 18.0571 9.43079 17.7074 8.34668 17.002"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14.2012 3.90979C15.0931 4.8016 15.3599 6.14285 14.8773 7.30809C14.3946 8.47334 13.2576 9.23311 11.9963 9.23311C10.7351 9.23311 9.59802 8.47334 9.11537 7.30809C8.63273 6.14285 8.89954 4.8016 9.7914 3.90979C10.3761 3.32478 11.1692 2.99609 11.9963 2.99609C12.8234 2.99609 13.6166 3.32478 14.2012 3.90979"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M12.0002 9.23047V15.0009"
      stroke="#222B3A"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
